// Composables
import { createRouter, createWebHistory } from 'vue-router'

async function beforeEnterHook(to, from, next) {
	const scriptId = 'disabled-ads' // DO NOT USE monetag! The ads are very intrusive on mobile! And the UI leaves much to be desired. Get super scammy vibes. 'ads-monetag'

	if (false && !document.getElementById(scriptId)) {
		const script = document.createElement('script')

		script.id = scriptId
		script.setAttribute('data-zone', '10426947')
		script.async = true
		script.type = 'text/javascript'
		script.src = 'https://nap5k.com/tag.min.js'

		document.head.appendChild(script)
	}

	if (false && /^\/rl/.test(to.path)) {
		const scriptId = 'ads-adsterra'

		if (!document.getElementById(scriptId)) {
			const script = document.createElement('script')

			script.id = scriptId
			script.async = 'async'
			script.type = 'text/javascript'
			script.src = 'https://entertainenslave.com/4a0665484716e3878af1d854e2ef9708/invoke.js'

			document.head.appendChild(script)
		}
	}

	next()
}

export default app => {
	const setupRoutes = $keycloak => {
		return [
            {
                path: '/popcorn',
                name: 'Popcorn',
                component: () => import('@/views/Popcorn.vue'),
            },
			{
				path: '/',
				name: 'DaD',
				component: () => import('@/views/HomePage.vue'),
				beforeEnter: beforeEnterHook,
			},
			{
				path: '/messenger-signup',
				name: 'DaD Messenger Sign Up ',
				component: () => import('@/views/MessengerPage.vue'),
			},
			{
				path: '/messenger/mt/:oid',
				name: 'DaD Message MT',
				component: () => import('@/views/MessengerPageMt.vue'),
			},
			{
				path: '/m/:messengerUsername',
				name: 'DaD Messenger Profile - Short URL',
				component: () => import('@/views/MessengerProfilePage.vue'),
			},
			{
				path: '/messenger/:messengerUsername',
				name: 'DaD Messenger Profile',
				component: () => import('@/views/MessengerProfilePage.vue'),
			},
			{
				path: '/messenger',
				name: 'DaD Messenger Dashboard',
				component: () => import('@/views/MessengerPage.vue'),
				beforeEnter: async (to, _from, next) => {
					await $keycloak.value.isLoaded
					// debugger
					if ($keycloak.value.authenticated) {
						next()
					} else {
						await $keycloak.value.login({
							redirectUri: `${window.location.origin}${to.fullPath}`,
						})
						next(false)
					}
				},
			},
			{
				path: '/rl',
				name: 'rl-index',
				title: 'DaD Request Line',
				beforeEnter: beforeEnterHook,
				component: () => import('@/views/RequestLinePage.vue'),
			},
			{
				path: '/rl/r/:code?',
				name: 'rl-relay',
				title: 'DaD Request Line Relay',
				beforeEnter: beforeEnterHook,
				component: () => import('@/views/RequestLinePage.vue'),
			},
			{
				path: '/message/:messageId',
				name: 'DaD Message Status',
				component: () => import('@/views/MessagePage.vue'),
			},
			{
				path: '/ad',
				name: 'DaD Ad',
				component: () => import('@/components/QrcodeAd.vue'),
			},
			{
				path: '/:catchAll(.*)',
				name: 'catchall',
				component: () => import('@/views/HomePage.vue'),
			},
		]
	}
	const router = createRouter({
		history: createWebHistory(process.env.BASE_URL),
		routes: setupRoutes(app.config.globalProperties.$keycloak),
		scrollBehavior(to, from, savedPosition) {
			// If the navigation is triggered to the same route (same path)
			if (to.path === from.path) {
				return { x: 0, y: 0 } // Scroll to the top
			}

			// If there is a savedPosition (back/forward navigation), restore the scroll position
			if (savedPosition) {
				return savedPosition
			}

			// For normal navigation between different routes, don't scroll to the top
			return { top: 0, left: 0 }
		},
	})

	app.use(router)
}
